import React, { Component } from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

class Notfound extends Component {
    render() {
        return (
            <div id="not-found-404">
                <div className="explain-box">
                    <div className="explain-box-left">
                        <ExclamationCircleOutlined className="not-found-icon" />
                    </div>
                    <div className="explain_box-right">
                        <h3>404 NOT FOUND</h3>
                        <p>該当するページが見つかりません</p>
                        <Button type="primary" className="button" onClick={()=>{window.location.href=("/")}}>
                            トップへ
                        </Button>
                    </div>
                </div>

            </div>
        );
    }
}

export default Notfound